var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Buffer } from 'buffer';
// helpers testing with jest in another project
import { REGEX } from '../constants';
import { DateTime } from 'luxon';
export var valueExist = function (value) {
    return value !== undefined && value !== null;
};
var objectCanBeMerged = function (item) {
    return item && typeof item === 'object' && !Array.isArray(item) && !(item instanceof DateTime);
};
export var deepMergeObj = function (obj1, obj2) {
    if (!valueExist(obj1) && !valueExist(obj2)) {
        return null;
    }
    if (!valueExist(obj1)) {
        return obj2;
    }
    if (!valueExist(obj2)) {
        return obj1;
    }
    var isObj1Mergeable = objectCanBeMerged(obj1);
    var isObj2Mergeable = objectCanBeMerged(obj2);
    if (!isObj1Mergeable) {
        if (isObj2Mergeable && Object.keys(obj2).length === 0) {
            return obj1;
        }
        return obj2;
    }
    var obj1Keys = Object.keys(isObj1Mergeable ? obj1 : {});
    var obj2Keys = Object.keys(isObj2Mergeable ? obj2 : {});
    var allKeys = new Set(__spreadArray(__spreadArray([], obj1Keys, true), obj2Keys, true));
    return Array.from(allKeys).reduce(function (acc, key) {
        var val1 = obj1[key];
        var val2 = obj2[key];
        if (valueExist(val1) && valueExist(val2)) {
            acc[key] = deepMergeObj(val1, val2);
        }
        else {
            acc[key] = valueExist(val2) ? val2 : val1;
        }
        return acc;
    }, {});
};
export var getPropsByKeyPath = function (obj, keyPath) {
    if (!keyPath || !obj) {
        console.warn('Warning translation missing, key could be wrong');
        return null;
    }
    var splitPath = keyPath.split('.');
    var isLast = splitPath.length === 1;
    var currentKey = splitPath[0];
    var isCurrentKeyArray = currentKey.match(/(\[[0-9]*])/);
    var nextKeyPath = keyPath.substring(keyPath.indexOf('.') + 1);
    if (isCurrentKeyArray) {
        var key = currentKey.substring(0, currentKey.indexOf('['));
        var index = Number.parseInt(currentKey.substring(currentKey.indexOf('[') + 1, currentKey.indexOf(']')), 10);
        return obj[key] && obj[key][index] ? (isLast ? obj[key][index] : getPropsByKeyPath(obj[key][index], nextKeyPath)) : null;
    }
    else {
        return obj[currentKey] ? (isLast ? obj[currentKey] : getPropsByKeyPath(obj[currentKey], nextKeyPath)) : null;
    }
};
/**
 * Apply js Object.hasOwnProperties recursively in given object
 * @param obj object to search in
 * @param keyPath the path in given object to reach the wanted key
 * @returns does the given key exist in specified object
 */
export var hasOwnDeepProperties = function (obj, keyPath) {
    if (!keyPath || !obj) {
        console.warn('Warning: falsy key or object found, given key could be wrong');
        return false;
    }
    var splitPath = keyPath.split('.');
    var isLast = splitPath.length === 1;
    var currentKey = splitPath[0];
    var isCurrentKeyArray = currentKey.match(/(\[[0-9]*])/);
    var nextKeyPath = keyPath.substring(keyPath.indexOf('.') + 1);
    if (isCurrentKeyArray) {
        var key = currentKey.substring(0, currentKey.indexOf('['));
        var index = Number.parseInt(currentKey.substring(currentKey.indexOf('[') + 1, currentKey.indexOf(']')), 10);
        return isLast ? index in obj[key] : hasOwnDeepProperties(obj[key][index], nextKeyPath);
    }
    else {
        return isLast ? currentKey in obj : hasOwnDeepProperties(obj[currentKey], nextKeyPath);
    }
};
// Not tested yet
export var isKeyMap = function (str) {
    var trimString = str.trim();
    return trimString.indexOf('.') !== -1;
};
export var keyMapWValueToObj = function (keyMap, value) {
    var _a, _b, _c;
    var indexOfSep = keyMap.indexOf('.');
    if (isKeyMap(keyMap)) {
        var firstKey = keyMap.substring(0, indexOfSep);
        var restKey = keyMap.substring(indexOfSep + 1);
        return _a = {},
            _a[firstKey] = keyMapWValueToObj(restKey, value),
            _a;
    }
    else {
        if (value !== null && typeof value === 'object') {
            return _b = {},
                _b[keyMap] = convertMixKeyMapAndObjToObj(value),
                _b;
        }
        else {
            return _c = {},
                _c[keyMap] = value,
                _c;
        }
    }
};
export var convertMixKeyMapAndObjToObj = function (obj) {
    if (!obj) {
        return null;
    }
    return Object.entries(obj).reduce(function (acc, _a) {
        var keyMap = _a[0], value = _a[1];
        var objParsed = keyMapWValueToObj(keyMap, value);
        return deepMergeObj(acc, objParsed);
    }, {});
};
export var parseStringToObj = function (str) {
    var splitStringByProperties = str
        .substring(1, str.length - 1)
        .trim()
        .split(',');
    var convertToObj = splitStringByProperties.reduce(function (acc, curr) {
        var _a;
        var _b = curr.split(':'), key = _b[0], value = _b[1];
        if (value) {
            var valueTrim = value.trim();
            var stringValue = valueTrim.match(REGEX.STRING);
            var cleanValue = stringValue ? valueTrim.substring(1, valueTrim.length - 1) : valueTrim;
            var canBeParseToNumber = Number.parseInt(cleanValue, 10);
            if (curr.length) {
                return __assign(__assign({}, acc), (_a = {}, _a[key] = canBeParseToNumber || cleanValue, _a));
            }
        }
        return acc;
    }, {});
    if (typeof convertToObj === 'object') {
        return convertToObj;
    }
    else {
        // thrown error ?
        return null;
    }
};
export var flatArrays = function (array) {
    if (!array || array.length < 1) {
        return [];
    }
    return array.reduce(function (acc, curr) {
        if (Array.isArray(curr)) {
            return __spreadArray(__spreadArray([], acc, true), flatArrays(curr), true);
        }
        else {
            return __spreadArray(__spreadArray([], acc, true), [curr], false);
        }
    }, []);
};
export var replaceInArray = function (array, index, newItem) {
    return array.map(function (item, arrayIndex) { return (arrayIndex === index ? newItem : item); });
};
export var objToBase64 = function (obj) {
    return new Buffer(JSON.stringify(obj)).toString('base64');
};
export var base64ToObj = function (base64) {
    try {
        return JSON.parse(new Buffer(base64, 'base64').toString('utf-8'));
    }
    catch (e) {
        console.error('Error while formatting base64 to object, probably wrong struct');
        return null;
    }
};
// Map an object and return an object type
export var iterateObj = function (obj, parsingValueFn) {
    if (!obj) {
        return {};
    }
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        var newValue = parsingValueFn(value);
        if (valueExist(newValue)) {
            return __assign(__assign({}, acc), (_b = {}, _b[key] = newValue, _b));
        }
        else {
            return acc;
        }
    }, {});
};
